import { render } from "./ImportView.vue?vue&type=template&id=7971ffaf&scoped=true"
import script from "./ImportView.vue?vue&type=script&lang=js"
export * from "./ImportView.vue?vue&type=script&lang=js"

import "./ImportView.vue?vue&type=style&index=0&id=7971ffaf&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7971ffaf"]])

export default __exports__